<template>
  <div class="box-main flexWarp smart-form">
    <p class="box-head1 midLay">安全教育</p>
    <div class="main-con">
      <!-- <div class="main-left">
        <el-tree
          :data="dataTree"
          ref="tree"
          node-key="id"
          :props="defaultProps"
          highlight-current
          @check-change="handleCheckChange"
          @node-click="handleNodeClick"
          @check="handlecheck"
        >
        </el-tree>
      </div> -->
      <div class="main-right flexWarp">
        <div class="filte-box">
          <div>
            <el-input placeholder="请输入姓名" v-model="search.name"></el-input>
          </div>
           <!-- <el-date-picker
              v-model="time"
              type="date"
              placeholder="选择日期">
            </el-date-picker> -->
          <el-button type="primary" @click="doFilter">查询</el-button>

          <el-button type="primary" plain 
            >导出报表</el-button
          >
          <div class="add">
            <el-button
              size="mini"
            
              style="color: #80b2ea; display: block"
            >
              按人员排序
              <i class="el-icon-sort"></i>
            </el-button>
            <el-button
              size="mini"
              style="color: #80b2ea; display: block"

            >
              按时长排序
              <i class="el-icon-sort"></i>
            </el-button>
          </div>
          
          <!-- <el-button type="primary" @click="exportFun">导出</el-button> -->
        </div>
        <div class="table-box">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            border
            height="100%"
            @selection-change="handleSelectionChange"
          >
            <template slot="empty">
              <p>{{ dataText }}</p>
            </template>
             <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <a>{{ scope.row.index}}</a>
                </template>
              </el-table-column>
              <el-table-column label="人员" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <a   @click="showProject(scope.row)" style="cursor: pointer;color:#81B3EA">{{ scope.row.name }}</a>
                  <!-- <a
                    @click="showProject(scope.row)"
                    style="cursor: pointer;color:#81B3EA"
                  >
                  </a> -->
                </template>
              </el-table-column>
              <el-table-column label="开始时间" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <a>{{ scope.row.createDate }}</a>
                </template>
              </el-table-column>
              <el-table-column label="结束时间">
                <template slot-scope="scope">
                  <a>{{ scope.row.endDate }}</a>
                </template>
              </el-table-column>
              <el-table-column label="时长" >
                <template slot-scope="scope">
                  <a>{{ scope.row.chuQin }}</a>
                </template>
              </el-table-column>
              <el-table-column label="观影名称">
                <template slot-scope="scope">
                  <a>{{ scope.row.teamsName }}</a>
                </template>
              </el-table-column>
          </el-table>
          <!-- 分页展示 -->
          <!-- <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalItems"
            style="padding-top: 10px"
          ></el-pagination> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
  data() {
    return {
      search: {
        //查询
        name: '',
        projectId: '',
        personStatus: '', // 0-在职；1-离职；2-未入职
        teamsId: '',
        entId: '',
        entName: '',
        time:''
      },
      time:util.myTime.getCurTime(),
      proEntId: '',
      checkProFlag: false, //
      checkedPros: [],
      projects: [],
      val: '',
      isIndeterminate: false,
      groupId: '',
      multipleSelection: [], //table行选择
      //checkedTime:false,//
      tableData: [], //列表数据
      projectId: '', //当前项目
      spanLine: {
        line_1: false,
        line_2: false,
        line_3: false,
        line_4: false,
        line_5: false,
        line_6: false,
        line_7: false,
      },
      //分页
      pageSize: 10,
      currentPage: 1,
      totalItems: 0,
      dataText: '数据加载中...',
      //金额价
      money: {
        cashContract: 0, //合同价
        beginningAppraisal: 0, //初审价
        endAppraisal: 0, //终审价
      },
      dataTree: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      currentNodekey: '', //默认选中的节点树
      checked: '',
      // time:''
    }
  },
  mounted() {
    this.groupId = util.session.get('groupId')
    this.getTableData()
    this.getMoney()
    // this.getProjectList()
    // this.getdataTree()
  },
  methods: {
    getdataTree() {
      var that = this
      myHttp
        .selectEntIdAndNameByEntIdAndJoinType({
          entId: this.groupId,
          // joinType:'3',
          flag: '2',
        })
        .then(function (resp) {
          // console.log(resp)
          if (resp.data.code == '200') {
            var list = resp.data.data || []
            var curKey = ''
            var projectEntId = ''
            var curProjectId = ''
            if (list.length > 0) {
              if (curKey == '') {
                curKey = list[0].children[0].projectId
                curProjectId = list[0].children[0].projectId
                projectEntId = list[0].children[0].id
              }
              // console.log(curKey, list[0].children[0])
              // for (var i = 0; i < list.length; i++) {
              //   if (list[0].children.length > 0) {
              //     for (var j = 0; j < list[i].children.length; j++) {
              //       list[i].children[j].parentId = list[i].id
              //     }
              //   }
              // }
            }
            that.dataTree = list
            that.proEntId = projectEntId
            that.search.projectId = curProjectId
            console.log(that.proEntId, that.projectId)
            that.getTableData()
            that.getMoney()
            setTimeout(function () {
              that.$refs.tree.setCurrentKey(curKey)
            }, 100)
          }
        })
    },
    doFilter(){
      this.getTableData()
    },
    //点击树形结构
    handleNodeClick(data) {
      // console.log(data)
      // this.proEntId = data.projectEntId
      if (data.type == '1') {
        this.search.projectId = data.id
        this.search.entId = ''
        this.search.teamsId = ''
      }
      if (data.type == '2') {
        this.projectId = data.projectId
        this.search.entId = data.id
        this.search.teamsId = ''

      }
      if (data.type == '3') {
         this.projectId = data.projectId
        // this.search.entId = data.id
        this.search.teamsId = data.id
      }
      this.getTableData()
    },
    handleCheckChange(data, parentCheck, nodeCheck) {
      // console.log(data,parentCheck,nodeCheck)
    },
    handlecheck(data, all) {
      console.log(data, all)
      this.allData = all
      var checked = all.checkedNodes
      console.log(checked)
      for (var i = 0; i < checked.length; i++) {
        if (checked[i].type == 1) {
          checked.splice(i, 1)
        }
      }
      this.checked = checked
    },
    //获取项目列表
    getProjectList() {
      var that = this
      myHttp
        .secProjectByEntIdAndJoinType({
          joinType: '3',
          entId: this.groupId,
          proEntId: this.proEntId,
        })
        .then(function (resp) {
          // console.log(resp)
          if (resp.data.code == '200') {
            var list = resp.data.data.list || []
            that.checkedPros = []
            if (list.length > 0) {
              that.checkedPros.push(list[0].id)
              that.projectId = list[0].id
            }
            that.projects = list
            that.getTableData()
            that.getMoney()
          }
        })
    },

    //获取合同价等
    getMoney() {
      var that = this
      this.money = {
        cashContract: 0, //合同价
        beginningAppraisal: 0, //初审价
        endAppraisal: 0, //终审价
      }
      myHttp
        .getEntProjectConfig({
          projectId: this.projectId,
          entId: this.proEntId,
        })
        .then(function (resp) {
          // console.log(resp)
          if (resp.data.code == '200') {
            var data = resp.data.data.wisdomForm
            if (data) {
              that.money = data
            }
          }
        })
    },

    //编辑合同价等数据
    saveMoney() {
      var that = this
      myHttp
        .createOrUpdateInfo({
          projectId: this.projectId,
          entId: this.groupId,
          beginningAppraisal: this.money.beginningAppraisal,
          endAppraisal: this.money.endAppraisal,
          cashContract: this.money.cashContract,
          createBy: util.session.get('user').id,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            that.$message.success('保存成功')
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getTableData()
    },

    //获取项目列表数据
    getTableData() {
      var that = this
      this.tableData = []
      this.search.projectId = this.groupId
      myHttp.getProjectPersonManagerList(this.search).then(
        function(resp) {
          if (resp.data.code == '200') {
           // console.log(resp)
            var list = resp.data.data.list || []
            for (var i = 0; i < list.length; i++) {
              for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
            }
            }
            that.tableData = list
            
            // that.getTypeName()
            if (that.tableData.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },

    //table多选点击
    handleSelectionChange(val) {
      this.multipleSelection = val
      // console.log(val)
    },

    handleCheckAllChange(val) {
      var projects = []
      for (var i = 0; i < this.projects.length; i++) {
        projects.push(this.projects[i].id)
      }
      this.checkedPros = val ? projects : []
      this.isIndeterminate = false
      //   console.log(this.checkedPros)
    },
    handleCheckedProChange(value) {
      let checkedCount = value.length
      this.checkProFlag = checkedCount === this.projects.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.projects.length
      //   console.log(this.checkedPros)
    },

    //点击选择项目
    selProjectFun(row) {
      if (row.id == this.projectId) return
      this.projectId = row.id
      this.getTableData()
    },
    // 数组去重
    ArrayToHeavy(arr) {
      //新建一个空数组
      let newArr = []
      for (var i = 0; i < arr.length; i++) {
        //遍历传入的数组，查找传入数组的值第一次出现的下标
        if (arr.indexOf(arr[i]) === i) {
          //push传入数组的一次出现的数字
          newArr.push(arr[i])
        }
      }
      return newArr
    },
    //

    //导出相应的数据
    exportFun() {
      var that = this
      if (this.checked.length == 0) {
        this.$message.error('请选择参建单位')
        return
      }

      //  console.log(projects,proEnt)

      // if (this.multipleSelection.length == 0) {
      //   this.$message.error('请选择导出行')
      //   return
      // }

      //项目选择
      // var projects = []
      // var proEnt = []
      var str = []
      for (var a = 0; a < this.checked.length; a++) {
        str.push({
          projectId: this.checked[a].projectId,
          entId: this.checked[a].id,
        })
      }
      str = JSON.stringify(str)
      console.log(str)
      // var projects = this.checkedPros.join(',')
      // for (var a = 0; a < this.checked.length; a++) {
      //   projects.push(this.checked[a].projectId)
      //   proEnt.push(this.checked[a].id)
      // }
      // projects = this.ArrayToHeavy(projects).join(',')
      // proEnt = this.ArrayToHeavy(proEnt).join(',')
      //行选择
      var rowList = ''
      for (var i = 0; i < this.multipleSelection.length; i++) {
        if (rowList == '') {
          rowList = this.multipleSelection[i].id
        } else {
          rowList += ',' + this.multipleSelection[i].id
        }
      }
      //列选择
      var lines = ''
      for (var key in this.spanLine) {
        if (this.spanLine[key]) {
          if (lines == '') {
            lines = key.split('_')[1]
          } else {
            lines += ',' + key.split('_')[1]
          }
        }
      }
      if (lines == '') {
        this.$message.error('请选择导出列')
        return
      }
      // console.log(projects)
      // console.log(rowList)
      // console.log(lines)
      // var token = util.session.get('token')
      myHttp
        .exportWisdomFormByEntId({
          entId: this.groupId,
          idStr: rowList,
          str: str,
          columns: lines,
        })
        .then(function (resp) {
          console.log(resp) //把response打出来，看下图
          let url = window.URL.createObjectURL(resp.data)
          console.log(url)
          var a = document.createElement('a')
          document.body.appendChild(a)
          a.href = url
          a.download = '智慧表单.xls'
          a.click()
          window.URL.revokeObjectURL(url)
          // if (resp.data.code == '200') {
          //   console.log(resp)
          // } else {
          //   that.$message.error(resp.data.msg)
          // }
        })
      // window.open(
      //   myHttp.exportWisdomFormByEntId +
      //     '?accessToken=' +
      //     token +
      //     '&entId=' +
      //     this.groupId +
      //     // '&projectId=' +
      //     // projects +
      //     // '&proEntId='+
      //     // proEnt +
      //     // '&idStr=' +
      //     // rowList +
      //     '&columns=' +
      //     lines
      // )
    },
    //查看个人
    showProject(row){
      // var name =row.name
      // this.$router.push({ path: '/eduPerson/'+name })
    }
  },
}
</script>

<style scoped>
.flexWarp {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  align-items: flex-start;
  justify-content: flex-start;
  justify-items: flex-start;
}
.midLay {
  display: flex;
  align-content: center;
  align-items: center;
}
.centerLay {
  display: flex;
  justify-content: center;
  justify-items: center;
}
.box-main {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0 1vh 1vh;
}
.box-head1 {
  width: 100%;
  height: 3vh;
  position: relative;
  font-size: 0.8vw;
  /* font-size: 1.5vw; */
  /* font-weight: bold; */
}
.main-con {
  width: 100%;
  height: calc(100% - 3vh);
  position: relative;
  display: flex;
}
.main-left {
  width: 20vw;
  height: 100%;
  position: relative;
  overflow: auto;
  border: 1px solid #ddd;
  background: #fff;
  padding: 0.5vh;
}

.main-right {
  /* width: calc(100% - 21vw); */
  width: 100%;
  height: 100%;
  position: relative;
  /* margin-left: 1vw; */
}
.filte-box {
  width: 100%;
  height: 10vh;
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0 1vw;
  align-content: center;
  align-items: center;
  background: #fff;
  border: 1px solid #ddd;
}
.table-box {
  width: 100%;
  height: calc(100% - 10vh);
  position: relative;
  margin-top: 1vh;
  background: #fff;
}

.check-span {
  width: calc(100% - 20px);
  word-break: normal;
  display: block;
  white-space: pre-wrap;
  margin: 0;
  cursor: pointer;
}
.check-span.cur {
  color: #409eff;
}
.box-main
  >>> .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  color: #4d95fd;
  font-weight: bold;
}
.cur {
  background: #80b2ea;
  color: #fff !important;
}
.act {
  background: #ecf5ff;
  color: #80b2ea !important;
}
.add {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.el-button + .el-button {
  margin-left: 0px;
  margin-top: 5px;
}
</style>

<style>
@import '../../../assets/css/common.css';
</style>